import {
  SET_SERVER_MESSAGE
} from "../application/types";
import {all, call, put, takeLatest} from "redux-saga/effects";
import {httpGet, httpPost} from "../../utils/HttpClient";
import { authService } from '../../index';

import {
  LOAD_APPLICATION_NOTIFICATIONS,
  LoadApplicationNotificationsAction,
  loadApplicationNotificationsSuccess,
  UPDATE_SINGLE_APPLICATION_NOTIFICATION,
  UpdateSingleApplicationNotificationAction,
  UpdateMultipleApplicationNotificationsAction,
  updateApplicationNotificationsSuccess,
  UPDATE_MULTIPLE_APPLICATION_NOTIFICATIONS
} from "./actions";
import {BrowserNotification} from "@amsanalytics/react-shared-library/build/Models/BrowserNotification";
import {displayError} from "../../utils/utils";

function* loadApplicationNotificationsSaga(action: LoadApplicationNotificationsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/notification/getNotifications`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      const browserNotifications: BrowserNotification[] = yield call([response, response.json]);
      yield put(loadApplicationNotificationsSuccess(browserNotifications));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchLoadApplicationNotificationsSaga() {
  yield takeLatest(LOAD_APPLICATION_NOTIFICATIONS, loadApplicationNotificationsSaga);
}


function* updateSingleApplicationNotificationSaga(action: UpdateSingleApplicationNotificationAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/notification/removesingle`,
      action.payload.applicationNotificationId,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      const browserNotifications: BrowserNotification[] = yield call([response, response.json]);
      yield put(updateApplicationNotificationsSuccess(browserNotifications));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchUpdateSingleApplicationNotificationSaga() {
  yield takeLatest(UPDATE_SINGLE_APPLICATION_NOTIFICATION, updateSingleApplicationNotificationSaga);
}


function* updateMultipleApplicationNotificationsSaga(action: UpdateMultipleApplicationNotificationsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/notification/removemultiple`,
      action.payload.applicationNotificationIds,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      const browserNotifications: BrowserNotification[] = yield call([response, response.json]);
      yield put(updateApplicationNotificationsSuccess(browserNotifications));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchUpdateMultipleApplicationNotificationsSaga() {
  yield takeLatest(UPDATE_MULTIPLE_APPLICATION_NOTIFICATIONS, updateMultipleApplicationNotificationsSaga);
}



export default function* applicationNotificationsSagas() {
  yield all([
    watchLoadApplicationNotificationsSaga(),
    watchUpdateSingleApplicationNotificationSaga(),
    watchUpdateMultipleApplicationNotificationsSaga()
  ])
}